import moment from 'moment';
import { setCookie } from '@bibliocommons/utils-browser';
import PreviewApi from 'app/api/PreviewApi';
import FeedbackApi from 'app/api/FeedbackApi';
import PreviewConstants from 'app/constants/PreviewConstants';

function setPreviewCookie(featureName, value) {
  const expires = moment()
    .add(1, 'years')
    .toDate();
  setCookie(`opt_in_feature_${featureName}`, value, { path: '/', expires });
}

export function optIn(featureName) {
  return {
    featureName,
    types: [PreviewConstants.OPT_IN_REQUEST, PreviewConstants.OPT_IN_SUCCESS, PreviewConstants.OPT_IN_FAILURE],
    apiRequest: (state, apiClient) => PreviewApi.optIn(featureName, apiClient),
    apiSuccess: response => {
      setPreviewCookie(featureName, true);
      return response;
    }
  };
}

export function optOut(featureName, currentLocation) {
  return {
    featureName,
    types: [PreviewConstants.OPT_OUT_REQUEST, PreviewConstants.OPT_OUT_SUCCESS, PreviewConstants.OPT_OUT_FAILURE],
    apiRequest: (state, apiClient) => PreviewApi.optOut(featureName, currentLocation, apiClient),
    apiSuccess: response => {
      setPreviewCookie(featureName, false);
      return response;
    }
  };
}

export function submitFeedback({ featureName, feedback, postSuccess, apiSuccess }) {
  return {
    featureName,
    middlewareData: {
      authRequired: true
    },
    types: [
      PreviewConstants.SUBMIT_OPT_IN_FEEDBACK_REQUEST,
      PreviewConstants.SUBMIT_OPT_IN_FEEDBACK_SUCCESS,
      PreviewConstants.SUBMIT_OPT_IN_FEEDBACK_FAILURE
    ],
    apiRequest: (state, apiClient) => FeedbackApi.submitFeedback(feedback, apiClient),
    apiSuccess,
    postSuccess
  };
}

export default {
  submitFeedback,
  optIn,
  optOut
};
